import {
  FETCH_DRIVERS_DOCUMENTS_DATA,
  FETCH_DRIVERS_DOCUMENTS_SUCCESS,
  FETCH_DRIVERS_DOCUMENTS_FAILURE,
} from "./actionTypes";

/**
 * @param {Object|string|number} params - Options object, or driverId only (backward compat)
 * @param {number} [params.page=1] - Page number (1-based)
 * @param {number} [params.limit=10] - Items per page
 * @param {string|number} [params.driverId] - Optional filter by driver ID
 */
export const fetchDriversDocumentsData = (params = {}) => {
  const isDriverIdOnly = typeof params === 'string' || typeof params === 'number';
  return {
    type: FETCH_DRIVERS_DOCUMENTS_DATA,
    payload: isDriverIdOnly
      ? { driverId: params, page: 1, limit: 10 }
      : { page: params.page ?? 1, limit: params.limit ?? 10, driverId: params.driverId },
  };
};

export const fetchDriversDocumentsSuccess = (data) => ({
  type: FETCH_DRIVERS_DOCUMENTS_SUCCESS,
  payload: data,
});

export const fetchDriversDocumentsFailure = (error) => ({
  type: FETCH_DRIVERS_DOCUMENTS_FAILURE,
  payload: error,
});
